<div id="contentMixitCloud" class="contentHeight">

    <searchMixitCloud *ngIf="variantes == null && formule == null" id="search" class="contentHeight"
        [colorCode]="colorCode"
        [manufacturer]="manufacturer"
        [country]="country"
        [langue]="langue"
        [seeFiltreColorWebTech]="seeFiltreColorWebTech"
        [applicationAccessoire]="applicationAccessoire"
        [teintesMeres]="teintesMeresResults"
        [searchCrit]="searchCrit"
        [teinteAccessoire]="teinteAccessoire"
        [teintesMeresAccessoire]="teintesMeresAccessoire"
        [infoAccessoire]="infoAccessoire"
        [selectedPart]="selectedPart"
        [listApplicationAccessoire]="listApplicationAccessoire"
        [seeMultiTon]="seeMultiTon"
        [teinteMultiTon]="teinteMultiTon"
        [teintesMeresMultiTon]="teintesMeresMultiTon"
        [infoMultiTon]="infoMultiTon"
        (listResultTeintesMeres)="search($event)"
        (listResultVariantes)="selectVariantes($event)"
        (resultTeintesMeresAccessoire)="selectAccessoire($event)"
        (listResultTeintesMeresAccessoire)="selectTeintesAccessoire($event)"
        (outputSelectedPart)="outputSelectPart($event)"
        (outputListApplicationAccessoire)="outputListApplicationAccessoire($event)"
        (outputResultTeintesMeresMultiTon)="outputResultTeintesMeresMultiTon($event)"
        (outputListResultTeintesMeresMultiTon)="outputListResultTeintesMeresMultiTon($event)"
        (outputLangue)="outputLangue()">
    </searchMixitCloud>

    <variantes *ngIf="variantes != null && formule == null" id="variantes"
        [country]="country"
        [langue]="langue"
        [infoVariantes]="infoVariantes"
        [variantes]="variantes"
        (resultFormule)="selectFormule($event)"
        [searchCrit]="searchCrit"
        (outputLangue)="outputLangue()">
    </variantes>

    <formule *ngIf="formule != null" id="formule"
        [country]="country"
        [langue]="langue"
        [formule]="formule"
        [variantes]="variantes"
        [variante]="variante"
        [teinteMeresSelected]="teinteMeresSelected"
        [searchCrit]="searchCrit"
        (outputLangue)="outputLangue()"
        (resultLigneFormule)="selectLigneFormule($event)">
    </formule>

    <!--Modale Loading-->
    <div id="loadingModal" class="modal">
        <div class="modal-content" id="loadingContent">

            <div class="loading">
                <img src="assets/loading.svg" alt="{{'stats.common.loading'|translate}}" />
            </div>
        </div>
    </div>

</div>
